<template>
  <app-layout>
    <template v-slot:default>
      <div class="text-start">

        <page-header>
          <h4 class="lh-1 m-0">{{ $t('binding_instance') }}</h4>
        </page-header>        

        <div v-if="current_instance" class="row mb-3 justify-content-center">
          <div class="col-12 col-sm-6">
            <label class="float-left">{{ $t("current_instance") }}</label>
            <p>{{ current_instance }}</p>
          </div>
        </div>

        <div class="row mb-3 justify-content-center">
          <div class="col-12 col-sm-6">
            <label for="new_instance" class="float-left mandatory">{{ $t("new_instance") }}</label>
            <div class="input-group">
              <!--input type="text" class="form-control" name="new_instance" ref="new_instance"-->
              <input type="text" class="form-control" v-model="new_instance">
            </div>
          </div>
        </div>

        <div class="row mb-3 justify-content-center">
          <div class="col-12 col-sm-6">
            <button class="btn btn-primary btn-lg btn-block float-end" @click="onCommitNewInstance" type="submit" id="submit">{{ $t("submit" )}}</button>
          </div>
        </div>              
      </div>

      <loading :active="is_loading"
        :can-cancel="false" 
        :is-full-page="true">
      </loading>

    </template>
  </app-layout>
</template>
<script>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n'

import instanceService from "@/services/InstanceService";
import { loadAllLookups } from '@/common/app_configs';

export default {
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const { t } = useI18n({ useScope: 'global' });

    const new_instance_name = route.query.instance
    const new_instance = ref(new_instance_name)
    const current_instance = store.getters.currentInstance;
    const is_loading = ref(false);

    console.log("Inside instances/Init.vue new_instance ==> ", new_instance)

    const onCommitNewInstance = async function() {
      await commitNewInstance();
    }

    const commitNewInstance = async function() {
      is_loading.value = true;
      console.log("Inside instances/Init.vue onCommitNewInstance: new_instance.value ==> ", new_instance.value);
      const new_instance_input = new_instance.value;

      if (new_instance_input == current_instance) {
        if (current_instance) {
          console.log("Inside instances/Init.vue onCommitNewInstance: same instance, redirect to ListSites ");
          // the same instance, just redirect
          router.push({ name: "ListSites" });
        }
      } else {
        if (await checkInstance(new_instance_input)) {
          if (new_instance_input && !current_instance) {
            // no current instance, no need to ask for confirmation.
            bindInstance(new_instance_input);
          } else {
            // has current instance && it's not the same as new one, ask confirmation
            if (confirm(t("binding_instance_confirm"))) {
              bindInstance(new_instance_input);
            } else {
              is_loading.value = false;
            }
          }
        } else {
          alert("Invalid instance name: " + new_instance_input)
          is_loading.value = false;
        }
      }
    }

    const bindInstance = async function(instance_name) {
      store.dispatch("bindInstance", instance_name);
      await loadAllLookups();
      router.push({ name: "ListSites" });
      is_loading.value = false;
    }

    const checkInstance = function(new_instance) {
      return instanceService.checkExist(new_instance);
    }

    if (new_instance.value) {
      commitNewInstance();
    }
    
    return {
      new_instance,
      current_instance,
      is_loading,
      onCommitNewInstance
    }
  }
}
</script>
